import React from 'react';

export const NotApplicable = () => {
  return (
    <div style={{color: 'light-dark(var(--moon-250), var(--moon-750))'}}>
      N/A
    </div>
  );
};
